import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Stack, Card, CardContent, CardActions, Avatar } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; 
import { toast } from "react-toastify";
import { apiURL, GetAll } from '../utils/apiCalls';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Dashboard = () => {
  const [locations, setLocations] = useState([]);

  async function GetList() {
    const response = await GetAll(apiURL + '/api/v1/map_project_locations?is_active=true');
    if (response) {
      if (response.data.status) {
        setLocations(response.data.data);
      } else {
        toast.error(response.data.message);
        setLocations([]);
      }
    }
  }

  useEffect(() => {
    GetList();
  }, []);

  const telanganaBounds = [
    [16.0, 77.0],
    [20.0, 81.0]
  ];

  const handleOpenGoogleMaps = (lat, lag) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lag}`;
    window.open(googleMapsUrl, '_blank');
  };

  const handleJoinWhatsApp = () => {
    const groupLink = "https://chat.whatsapp.com/EXAMPLE_LINK"; // replace with actual link
    window.open(groupLink, '_blank');
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          MAP & SOCIAL GROUP
        </Typography>
      </Stack>

      {/* WhatsApp Group Card */}
      <Card
        sx={{
          position: 'absolute',
          top: 80,
          right: 20,
          width: 280,
          zIndex: 1000,
          boxShadow: 4,
          borderRadius: 3,
          backgroundColor: '#ffffffb8',
          backdropFilter: 'blur(6px)',
        }}
      >
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar sx={{ bgcolor: '#25D366' }}>
              <WhatsAppIcon />
            </Avatar>
            <Box>
              <Typography variant="h6">Community Group</Typography>
              <Typography variant="body2" color="text.secondary">
                Stay updated with the latest project info.
              </Typography>
            </Box>
          </Stack>
        </CardContent>
        <CardActions>
          <Button
            fullWidth
            variant="contained"
            startIcon={<WhatsAppIcon />}
            sx={{
              bgcolor: '#25D366',
              '&:hover': { bgcolor: '#1ebe5d' },
              borderRadius: 2,
              fontWeight: 600
            }}
            onClick={handleJoinWhatsApp}
          >
            Join WhatsApp
          </Button>
        </CardActions>
      </Card>

      {/* Map Section */}
      <MapContainer
        center={[17.385044, 78.486671]}
        zoom={7}
        style={{ width: '100%', height: '500px', marginTop: '20px' }}
        bounds={telanganaBounds}
        maxBounds={telanganaBounds}
        maxBoundsViscosity={1.0}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution=""
        />
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={[location.lat, location.lag]}
            icon={new L.Icon({
              iconUrl: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
              iconSize: [25, 25],
              iconAnchor: [12, 12],
            })}
          >
            <Tooltip direction="right" offset={[0, 0]} permanent>
              {location.name}
            </Tooltip>
            <Popup>
              <div>
                <strong>{location.name}</strong><br />
                {location.description}
              </div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenGoogleMaps(location.lat, location.lag)}
                style={{ marginTop: '10px' }}
              >
                Maps
              </Button>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </Box>
  );
};

export default Dashboard;
